import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function usePagedList(url, token, filters) {
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], total: 0, page: 1, pages: 1 });
  const [loading, setLoading] = useState(false);
  const key = JSON.stringify(filters);
  useEffect(() => { setPage(1); }, [key]);
  const load = useCallback(async () => {
    setLoading(true);
    try { const { data: d } = await axios.get(url, { params: { page, ...filters }, headers: { Authorization: `Bearer ${token}` } }); setData(d); }
    catch { /* ignore */ } finally { setLoading(false); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, token, page, key]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);
  const setItems = (fn) => setData((d) => ({ ...d, items: fn(d.items) }));
  return { ...data, loading, setPage, reload: load, setItems };
}

export function StateChips({ options, value, onChange, testid }) {
  return (
    <div className="flex flex-wrap gap-2 mb-5" data-testid={testid}>
      {options.map((o) => (
        <button key={o.key} onClick={() => onChange(o.key)} data-testid={`${testid}-${o.key || "all"}`}
          className={`inline-flex items-center gap-2 px-3 py-1.5 text-xs border transition-colors ${value === o.key ? "bg-[#D4AF37] border-[#D4AF37] text-black font-semibold" : "border-white/15 text-white/65 hover:border-[#D4AF37]/60 hover:text-white"}`}>
          {o.label}
          {o.count != null && <span className={value === o.key ? "text-black/70" : "text-white/40"}>{o.count}</span>}
          {o.sum != null && <span className={value === o.key ? "text-black/70" : "text-[#D4AF37]/80"}>· {Number(o.sum).toFixed(2)} €</span>}
        </button>
      ))}
    </div>
  );
}

export default function AdminPager({ page, pages, total, onPage, testid = "pager" }) {
  if (pages <= 1) return null;
  const btn = "inline-flex items-center gap-1 border border-white/15 px-3 py-1.5 text-sm hover:border-[#D4AF37] hover:text-[#D4AF37] disabled:opacity-30 disabled:hover:border-white/15 disabled:hover:text-inherit transition-colors";
  return (
    <div className="flex items-center justify-between gap-3 mt-6" data-testid={testid}>
      <span className="text-white/40 text-xs" data-testid={`${testid}-info`}>Strana {page} z {pages} · {total} záznamov</span>
      <div className="flex items-center gap-2">
        <button className={btn} disabled={page <= 1} onClick={() => { onPage(page - 1); window.scrollTo({ top: 0, behavior: "smooth" }); }} data-testid={`${testid}-prev`}><ChevronLeft size={15} /> Predošlá</button>
        <button className={btn} disabled={page >= pages} onClick={() => { onPage(page + 1); window.scrollTo({ top: 0, behavior: "smooth" }); }} data-testid={`${testid}-next`}>Ďalšia <ChevronRight size={15} /></button>
      </div>
    </div>
  );
}
